// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Antonio_a020ea', '__Antonio_Fallback_a020ea', Inter, system-ui, Segoe UI, Arial, sans-serif","fontStyle":"normal"},"className":"__className_a020ea"};